import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";
import ShieldIcon from "@mui/icons-material/Shield";
import SyncDisabledOutlinedIcon from "@mui/icons-material/SyncDisabledOutlined";
import StyledTooltip from "../tooltips/StyledTooltip";

const DataSourceIcon = ({dataSource, sx}) => {
  const icon =
    dataSource === "GOLD" ?
      (
        <ShieldIcon fontSize="small" color="primary" />
      ) :
      dataSource === "MODIFIED" ?
        (
          <SyncDisabledOutlinedIcon fontSize="small" color="primary" />
        ) :
        null;
  const tooltipTitle =
    dataSource === "GOLD" ?
      (
        "Managed by BreachRx"
      ) :
      dataSource === "MODIFIED" ?
        (
          <>
            Modified by your organization
            <br />
            BreachRx updates are disabled
          </>
        ) :
        null;

  if (!icon) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" height="100%" sx={sx}>
      <StyledTooltip
        title={tooltipTitle}
        spanProps={{style: {display: "flex", alignItems: "center"}}}
      >
        {icon}
      </StyledTooltip>
    </Box>
  );
};

DataSourceIcon.propTypes = {
  dataSource: PropTypes.string,
  sx: PropTypes.object,
};

export default DataSourceIcon;
